<template>
  <div id="app">
    <div class="hero">
      <div class="wrap grid-center">
        <div class="grid-8 grid-offset-2 text-center">
          <h1>RECOVERY TIME CALCULATOR</h1>
          <p>Evaluate your Recovery Time and Recovery Point Objectives</p>
        </div>
      </div>
    </div>
    <calculator></calculator>
  </div>

</template>

<script>
import Calculator from './components/Calculator';

export default {
  name: 'app',
  components: {
    Calculator,
  },
  data() {
    return {
      recoveryTimeObjective: 173520,
      rtoInputs: {
        recoveryTimeObjective: 84,
        recoveryPointObjective: 84,
      },
    };
  },
};
</script>

<style>
* {
  box-sizing: border-box;
}
html {
  background-color: #002A3A;
}
body {
  margin: 0;
  color: white;
}
.hero {
  padding-left: 15px;
  padding-right: 15px;
  background-image: url('./assets/images/graph-bg.svg');
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  min-height: 400px;
  background-image: url('./assets/images/graph-bg.svg'), linear-gradient(-180deg, #1A6D7D 0%, #002A3A 100%);
  display: flex;
}
.hero:before {
  content: '';
  display: block;
  position: absolute;
  top: -2vw;
  left: 0;
  z-index: 3;
  border-width: 0px 50vw 2vw 0vw;
  border-style: solid;
  border-color: transparent transparent #0C475D transparent;
}
.hero:after {
  content: '';
  display: block;
  position: absolute;
  bottom: -2vw;
  right: 0;
  z-index: 3;
  border-width: 0px 50vw 2vw 0vw;
  border-style: solid;
  border-color: transparent #002A3A transparent transparent;
}

.hero svg::after {
  content: 'test';
  width: 40px;
  height: 10px;
  background-color: #F64A35;
  position: absolute;
}

h2 {
  color: #07F0D7;
  margin-bottom: 64px;
  font-size: 2em;
}
h2:after {
  content: ' ';
  width: 25px;
  height: 3px;
  background-color: #1A5064;
  display: block;
  position: relative;
  bottom: -10px;
}

.section-padding {
  padding: 120px 0;
}
</style>



// WEBPACK FOOTER //
// App.vue?0f868b79